module.exports = __webpack_public_path__ + "SourceSans3-ExtraLight.otf.121e9.woff";